<template>
  <div class="">
    <!-- <h1 class="tc">Portfolio</h1> -->
    <div class="cf">
      <div class="container" v-for="i in projects.length" :key="i">
        <div class="tc w-100 w-50-ns ph2-ns pb3 pb3-l" :class="i < projects.length-1 ? 'fl' : 'fr'">
          <router-link class="" :to="{ name: 'project', params: { project: projects[i-1].link} }" :project="projects[i-1]">
            <div id="image" class="wrapper">
              <img class="image db v-mid absolute--fill" v-lazy="require(`@/assets/${projects[i-1].cover}`)"/>
            </div>
            <div id="text" class="tl text f2-ns f4-m f3 pa3 black">{{ projects[i-1].name }}</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as PROJECTS from '@/data.js'
import Project from '@/pages/Project.vue'
export default {
  name: 'Portfolio',
  data: function() {
    return {
      projects: PROJECTS,
      mobile: null,
      components: {
        Project
      }
    }
  }
};
</script>

<style scoped>
img {
  width: 100%;
}
.container {
  position: relative;
}
.wrapper {
  height: 500px;
}
.image {
  height: 500px;
}
@media screen and (min-width: 961px){
  .text {
    transform: translate(0px, -100px);
  }
}
@media screen and (max-width: 960px){
  .text {
    transform: translate(0px, -50px);
  }
}
@media screen and (max-width: 738px){
  .text {
    transform: translate(0px, -75px);
  }
}
@media screen and (min-width: 801px){
  .text {
    opacity: 0;
  }
  .image {
    opacity: 1;
  }
}
@media screen and (max-width: 1100px){
  .text {
    opacity: 1;
  }
  .image {
    opacity: 0.5;
    height: 300px;
  }
  .wrapper {
    height: 300px;
  }
}
.text {
  position: absolute;
  transition: 0.5s ease;
}
.container:hover .text {
  opacity: 1;
}
.container:hover .image {
  /* transition: 0.5s ease; */
  opacity: 0.8;
}
</style>
